import React from "react";

const variantClasses = {
  default:
    "rounded-xl bg-white dark:bg-slate-800 p-8 shadow-[0_12px_24px_rgba(15,23,42,0.12)] dark:shadow-[0_12px_24px_rgba(0,0,0,0.3)]",
  pos: "pos-card p-6",
  "pos-stat": "pos-stat-card p-5",
  glass: "pos-glass p-6",
};

const Card = ({ children, className = "", variant = "default" }) => {
  return (
    <div
      className={[
        "w-full",
        variantClasses[variant] || variantClasses.default,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
};

export default Card;
